import { gql } from '@apollo/client';

const APPROVE_OR_DECLINE_TRANSLATE_IMPROVEMENT_MUTATION = gql`
  mutation approveOrDeclineTranslateImprovement($id: Int!, $isApproved: Boolean!) {
    translateImprovement {
      approveOrDeclineTranslateImprovement: approveOrDecline(id: $id, isApproved: $isApproved)
    }
  }
`;

export { APPROVE_OR_DECLINE_TRANSLATE_IMPROVEMENT_MUTATION };
